import React from 'react';
import {usePrimeCache} from "../../../Hooks/ServiceHooks";
import {service as SpeciesRequestStatusService} from "../../../Services/SpeciesRequestStatusService";
import {ObjectUtils} from "../../../Utils";

export const ServiceDrivenTableColumn = (service) => ((props) => {

    usePrimeCache([service]);

    const {Value} = props;
    
    if(!service.cached) {
        return "Loading...";
    }
    
    const title = service.CachedTitleById(Value);
    const code = service.CachedValueById(Value)?.result?.code;
    const className = code ? `sb-${service.CssClassName}-${code}` : null;

    return <span className={className} >{title ?? 'N/A'}</span>;
});
